import { CircularProgress, Grid } from '@material-ui/core';
import React, { useContext } from 'react';
import { CompanyDetails } from './companyDetails';
import InsuranceDetails from './insuranceDetails';
import LoanVehicleDetails from './loanVehicleDetails';
import BookingDetails from './bookingDetails';
import Note from './note';
import { LoanVehicleContext, LoanVehicleProvider } from './loanVehicle-provider';
import { SecondaryButton } from '../../../Core/FormInput';
import moment from 'moment';
import { Alert } from '@material-ui/lab';
import { HandoverOUtSignature, HandoverReturnSignature } from './handoverOUtSignature';
import DialogComp from '../../../Core/Modal/dialogModal';
import './loanStyle.scss';
import { use } from 'react';
import AppContext from '../../../App/AppContext';

const LoanVehicleBooking = (props) => {
    const { handleCancel, state, loading, handleSave, handleTc, handleSaveIn, handleSaveOut, isoutSignatureompleted, isInSignatureCompleted } =
        useContext(LoanVehicleContext);
    const { portalSettings } = useContext(AppContext);

    return (
        <div style={{ padding: 15, background: 'white' }}>
            {state.loading ? (
                <Grid container spacing={2}>
                    <Grid item xs={12} style={{ textAlign: 'center', padding: '50px 0px' }}>
                        <CircularProgress />
                    </Grid>
                </Grid>
            ) : (
                <Grid container spacing={2}>
                    <Grid item md={12}>
                        <LoanVehicleDetails />
                    </Grid>

                    <Grid item md={12}>
                        <CompanyDetails />
                    </Grid>

                    <Grid item md={12} lg={12}>
                        <InsuranceDetails />
                    </Grid>

                    <Grid item md={12} lg={6}>
                        <HandoverOUtSignature />
                    </Grid>

                    <Grid item md={12} lg={6}>
                        <HandoverReturnSignature />
                    </Grid>

                    {!isInSignatureCompleted && (
                        <Grid item xs={12} sm={4}>
                            <SecondaryButton fullWidth onClick={handleSave} disabled={loading}>
                                {loading ? <CircularProgress size={20} /> : 'Save'}
                            </SecondaryButton>
                        </Grid>
                    )}

                    {!isInSignatureCompleted && (
                        <Grid item xs={12} sm={4}>
                            <SecondaryButton fullWidth onClick={isoutSignatureompleted ? handleSaveIn : handleSaveOut} disabled={loading}>
                                {loading ? <CircularProgress size={20} /> : isoutSignatureompleted ? 'Vehicle Returned' : 'Handover Vehicle'}
                            </SecondaryButton>
                        </Grid>
                    )}

                    <Grid item xs={12} sm={!isInSignatureCompleted ? 4 : 12}>
                        <SecondaryButton fullWidth onClick={handleCancel}>
                            Cancel
                        </SecondaryButton>
                    </Grid>

                    {state.openTc ? (
                        <DialogComp maxWidth="sm" onClose={handleTc} open={state.openTc} title="Terms and Conditions">
                            <div style={{ padding: '0px 5px', maxHeight: '100vh', overflowY: 'auto' }}>
                                <div className="terms-conditions-body">
                                    {portalSettings && portalSettings.portalSettingLoanVehicleTerms ? (
                                        <div dangerouslySetInnerHTML={{ __html: portalSettings.portalSettingLoanVehicleTerms }} />
                                    ) : (
                                        'No Terms and Conditions found'
                                    )}
                                </div>
                            </div>
                        </DialogComp>
                    ) : null}
                </Grid>
            )}
        </div>
    );
};
let ProviderScreen = (props) => {
    return (
        <LoanVehicleProvider {...props}>
            <LoanVehicleBooking {...props} />
        </LoanVehicleProvider>
    );
};
export default ProviderScreen;
